export const pharmacopoeiaDescriptions: { [key: string]: string } = {
  "FDA": "U.S. Food and Drug Administration",
  "EMA": "European Medicines Agency",
  "CFDA": "China Food and Drug Administration",
  "HMA": "Heads of Medicines Agencies",
  "NDC": "National Drug Code",
  "PMDA": "Pharmaceuticals and Medical Devices Agency",
  "DMF": "Drug Master File",
  "USP": "US Pharmacopeia",
  "EUP": "European Pharmacopoeia"
};

const textNotAuth = "Please log in to see this information";
export const configMainDataNotAuth = [
  {
    label: "Targets",
    value: textNotAuth
  },
];

export const pharmacopoeiaItems = ({ data, className }: any) => {
  return data?.map((item: any, index: number) => {
    const description = pharmacopoeiaDescriptions[item] || "No description available";
    return (
      <span key={index} className={className || ""} title={description}>
        {item}
      </span>
    );
  });
};
